import React from 'react'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useJetAlertsContextValue } from '../context/JetAlertsProvider'

export const JetAlertsHeader = () => {
  const { state, actions } = useJetAlertsContextValue()

  return (
    <Header
      title="Jet Alerts"
      rightContent={
        <QueryStatus
          dataUpdatedAt={state.dataUpdatedAt}
          isFetching={state.isFetching}
          refetch={actions.refetch}
          isError={state.isError}
          error={state.error}
        />
      }
    />
  )
}
